import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61d3d5c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tab-nav"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "p-3 bg-white border-top border-bottom border-gray-03" }
const _hoisted_4 = {
  class: "ribbon-head",
  ref: "orderOverview"
}
const _hoisted_5 = { class: "py-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          仕事詳細\n        ", -1))
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "さらに表示", -1))
const _hoisted_9 = {
  class: "ribbon-head mt-3",
  id: "applicationCondition",
  ref: "applicationCondition"
}
const _hoisted_10 = { class: "wrapper" }
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n              業務に関する書類\n            ", -1))
const _hoisted_13 = { class: "py-3" }
const _hoisted_14 = { class: "d-flex justify-content-between" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n                資格条件\n              ", -1))
const _hoisted_16 = { class: "mt-2" }
const _hoisted_17 = {
  key: 0,
  class: "tag-outline mr-2 mb-2"
}
const _hoisted_18 = ["data-testid"]
const _hoisted_19 = { class: "py-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n              経験・スキル\n            ", -1))
const _hoisted_21 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_22 = {
  key: 1,
  class: "text-size-14 text-mild"
}
const _hoisted_23 = { class: "py-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n              服装・身だしなみ\n            ", -1))
const _hoisted_25 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_26 = {
  key: 1,
  class: "text-size-14 text-mild"
}
const _hoisted_27 = { class: "py-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n              服装写真\n            ", -1))
const _hoisted_29 = { class: "row align-items-center mt-2 mx-n1" }
const _hoisted_30 = ["href"]
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "row align-items-start mt-2 mx-n1" }
const _hoisted_33 = { class: "py-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n              持ち物・その他の条件\n            ", -1))
const _hoisted_35 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_36 = {
  key: 1,
  class: "text-size-14 text-mild"
}
const _hoisted_37 = {
  class: "ribbon-head mt-3",
  ref: "officeInfo"
}
const _hoisted_38 = { class: "pt-3 pb-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          法人名\n        ", -1))
const _hoisted_40 = { class: "mt-1 text-size-14 text-mild" }
const _hoisted_41 = { class: "pt-3 pb-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          事業所名\n        ", -1))
const _hoisted_43 = { class: "mt-1 text-size-14 text-mild" }
const _hoisted_44 = { class: "pt-3 pb-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          連絡先\n        ", -1))
const _hoisted_46 = { class: "mt-1 text-size-14 text-mild" }
const _hoisted_47 = { class: "py-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          住所\n        ", -1))
const _hoisted_49 = { class: "mt-1 text-size-14 text-mild" }
const _hoisted_50 = { class: "py-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          アクセス\n        ", -1))
const _hoisted_52 = { class: "mt-1 text-size-14 text-mild" }
const _hoisted_53 = { class: "py-2" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          可能な通勤手段\n        ", -1))
const _hoisted_55 = {
  key: 0,
  class: "py-2"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          駐車場\n        ", -1))
const _hoisted_57 = { class: "mt-1 text-size-14 text-mild" }
const _hoisted_58 = {
  key: 1,
  class: "py-2"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n          通勤手段の備考\n        ", -1))
const _hoisted_60 = { class: "mt-1 text-size-14 text-mild" }
const _hoisted_61 = {
  class: "ribbon-head mt-3",
  ref: "review"
}
const _hoisted_62 = { class: "mb-2 py-3" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-1 text-size-14 text-weight-500 text-primary-dark" }, "\n          総合評価\n        ", -1))
const _hoisted_64 = { class: "mb-2" }
const _hoisted_65 = { class: "d-flex align-items-center mb-1 text-size-14 text-weight-500 text-primary-dark" }
const _hoisted_66 = { class: "tag-outline ml-2" }
const _hoisted_67 = {
  key: 0,
  class: "ml-2 material-symbols-outlined pin-icon"
}
const _hoisted_68 = { class: "ml-auto text-gray-05 text-size-14" }
const _hoisted_69 = { class: "text-size-14 text-mild" }
const _hoisted_70 = { class: "text-size-14 text-mild" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-2" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_72 = {
  key: 1,
  class: "d-flex justify-content-center text-gray-05 text-size-14"
}
const _hoisted_73 = {
  key: 0,
  class: "update-date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ConfirmRoute = _resolveComponent("ConfirmRoute")!
  const _component_CommuteMethodTags = _resolveComponent("CommuteMethodTags")!
  const _component_EvaluationWithoutCount = _resolveComponent("EvaluationWithoutCount")!
  const _component_AppLabel = _resolveComponent("AppLabel")!
  const _component_ReviewComment = _resolveComponent("ReviewComment")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionList, (section, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: _normalizeClass(["tab-nav-item", { active: _ctx.activeSectionName === section.name }]),
              onClick: ($event: any) => (_ctx.scrollToRef(section.name))
            }, _toDisplayString(section.text), 11, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, "仕事概要", 512),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createTextVNode(),
        _createElementVNode("div", {
          class: _normalizeClass(["order-detail-text-wrapper", _ctx.expandedClasses])
        }, [
          _createElementVNode("p", {
            ref: "orderDetailText",
            class: "mt-3 text-size-14 text-mild text-break text-pre-wrap order-detail-text",
            innerHTML: _ctx.linkifyOrderDescription
          }, null, 8, _hoisted_7),
          _createTextVNode(),
          (_ctx.expandDescriptionEnabled && !_ctx.isDescriptionExpanded)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "w-100 text-center expand-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expandDescription && _ctx.expandDescription(...args)))
              }, [
                _hoisted_8,
                _createTextVNode(),
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-down",
                  class: "mr-1"
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createTextVNode(),
      _createElementVNode("h2", _hoisted_9, "\n        申込条件\n      ", 512),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createTextVNode(),
            _createElementVNode("button", {
              class: "btn-order mt-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click-notice-of-employment')))
            }, "\n              労働条件通知書を確認\n            "),
            _createTextVNode(),
            (_ctx.order.attachmentFile)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-order mt-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click-attachment-file')))
                }, "\n              その他の書類を確認\n            "))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createTextVNode(),
              (_ctx.isLogin || _ctx.isPreview)
                ? (_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    to: { name: 'MypageQualificationList' },
                    tag: "div",
                    class: "text-size-14 text-blue",
                    style: _normalizeStyle(_ctx.isPreview ? 'pointer-events: none' : null)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("\n                資格の登録を更新\n              ")
                    ], undefined, true),
                    _: 1
                  }, 8, ["style"]))
                : _createCommentVNode("", true)
            ]),
            _createTextVNode(),
            _createElementVNode("ul", _hoisted_16, [
              (_ctx.order.allowUnqualified)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, "\n                なし\n              "))
                : _createCommentVNode("", true),
              _createTextVNode(),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.qualifications, (qualification) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: qualification.id,
                  "data-testid": `qualification-${qualification.id}`,
                  class: _normalizeClass(["tag-outline mr-2 mb-2", {
                  'tag-outline--yellow': _ctx.hasQualification(qualification.id)
                }])
                }, _toDisplayString(qualification.name), 11, _hoisted_18))
              }), 128))
            ]),
            _createTextVNode(),
            (
                !_ctx.order ||
                  (!_ctx.order.allowUnqualified &&
                    (!_ctx.order.qualifications ||
                      _ctx.order.qualifications.length === 0))
              )
              ? _renderSlot(_ctx.$slots, "unsetQualifications", { key: 0 }, undefined, true)
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(),
            (_ctx.otherConditionList.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherConditionList, (otherCondition, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "list-text text-size-14 text-mild"
                    }, "\n                ・" + _toDisplayString(otherCondition), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, "\n              指定なし\n            ")),
            _createTextVNode(),
            (_ctx.otherConditionList.length === 0)
              ? _renderSlot(_ctx.$slots, "unsetOtherConditionList", { key: 2 }, undefined, true)
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createTextVNode(),
            (_ctx.clothesConditionList.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clothesConditionList, (clothesCondition, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "list-text text-size-14 text-mild"
                    }, "\n                ・" + _toDisplayString(clothesCondition), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, "\n              指定なし\n            ")),
            _createTextVNode(),
            (_ctx.clothesConditionList.length === 0)
              ? _renderSlot(_ctx.$slots, "unsetClothesConditionList", { key: 2 }, undefined, true)
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createTextVNode(),
            _createElementVNode("ul", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clothesSampleList, (clothesSample, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "col-4 px-1"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: _ctx.getOptimizedImageUrl(clothesSample.image),
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.getOptimizedImageUrl(clothesSample.image),
                        alt: "",
                        class: "w-100"
                      }, null, 8, _hoisted_31)
                    ], 8, _hoisted_30)
                  ])
                ]))
              }), 128))
            ]),
            _createTextVNode(),
            _createElementVNode("ul", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clothesSampleList, (clothesSample, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "col-4 px-1 text-size-12 text-mild text-center"
                }, _toDisplayString(clothesSample.comment), 1))
              }), 128))
            ]),
            _createTextVNode(),
            (_ctx.clothesSampleList.length === 0)
              ? _renderSlot(_ctx.$slots, "unsetClothesSampleList", { key: 0 }, undefined, true)
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createTextVNode(),
            (_ctx.belongingsList.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.belongingsList, (belongings, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "list-text text-size-14 text-mild"
                    }, "\n                ・" + _toDisplayString(belongings), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, "\n              指定なし\n            "))
          ]),
          _createTextVNode(),
          (_ctx.belongingsList.length === 0)
            ? _renderSlot(_ctx.$slots, "unsetBelongingsList", { key: 0 }, undefined, true)
            : _createCommentVNode("", true)
        ])
      ]),
      _createTextVNode(),
      _createElementVNode("h2", _hoisted_37, "事業所情報", 512),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.getOfficeProp("corporationName")), 1)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.getOfficeProp("name")), 1)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.getOfficeProp("phoneNumber")), 1)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_47, [
        _hoisted_48,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.getOfficeProp("address")), 1),
        _createTextVNode(),
        _createVNode(_component_ConfirmRoute, {
          latitude: _ctx.getOfficeProp('latitude'),
          longitude: _ctx.getOfficeProp('longitude'),
          mapStyle: _ctx.isPreview ? 'pointer-events:none' : null,
          onConfirmRoute: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click-view-root')))
        }, null, 8, ["latitude", "longitude", "mapStyle"])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_50, [
        _hoisted_51,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.getOfficeProp("access")), 1)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_53, [
        _hoisted_54,
        _createTextVNode(),
        _createVNode(_component_CommuteMethodTags, {
          class: "mt-1",
          canCommuteByCar: _ctx.getOfficeProp('canCommuteByCar'),
          canCommuteByBike: _ctx.getOfficeProp('canCommuteByBike'),
          canCommuteByBicycle: _ctx.getOfficeProp('canCommuteByBicycle'),
          canCommuteByPublicTransit: 
            _ctx.getOfficeProp('canCommuteByPublicTransit')
          
        }, null, 8, ["canCommuteByCar", "canCommuteByBike", "canCommuteByBicycle", "canCommuteByPublicTransit"])
      ]),
      _createTextVNode(),
      (_ctx.isShowingParkingType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _hoisted_56,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.parkingTypeText), 1)
          ]))
        : _createCommentVNode("", true),
      _createTextVNode(),
      (_ctx.getOfficeProp('commuteMethodNote'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _hoisted_59,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.getOfficeProp("commuteMethodNote")), 1)
          ]))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("h2", _hoisted_61, "レビュー", 512),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_62, [
        _hoisted_63,
        _createTextVNode(),
        (
            _ctx.evaluationCount !== undefined &&
              _ctx.evaluationTotalAverage !== undefined
          )
          ? (_openBlock(), _createBlock(_component_EvaluationWithoutCount, {
              key: 0,
              value: _ctx.evaluationTotalAverage,
              count: _ctx.evaluationCount,
              size: "24",
              textSize: "16"
            }, null, 8, ["value", "count"]))
          : _createCommentVNode("", true)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_64, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAnonymousEvaluations, (evaluation) => {
          return (_openBlock(), _createElementBlock("div", {
            key: evaluation.id,
            class: "mb-0"
          }, [
            _createElementVNode("h3", _hoisted_65, [
              _createElementVNode("div", null, _toDisplayString(evaluation.roundedAge) + "代\n              " + _toDisplayString(_ctx.getSexLabel(evaluation.sex)), 1),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.getQualificationName(evaluation.qualificationId)), 1),
              _createTextVNode(),
              (evaluation.isFeatured)
                ? (_openBlock(), _createElementBlock("i", _hoisted_67, "keep"))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_68, _toDisplayString(evaluation.monthsAgo > 0
                  ? `${evaluation.monthsAgo}ヶ月前`
                  : "1ヶ月以内"), 1)
            ]),
            _createTextVNode(),
            _createVNode(_component_AppLabel, {
              variant: "success",
              class: "mr-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode("良い点 ")
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_69, [
              _createVNode(_component_ReviewComment, {
                comment: evaluation.goodPoint,
                maxLength: 150
              }, null, 8, ["comment"])
            ]),
            _createTextVNode(),
            _createVNode(_component_AppLabel, {
              variant: "mild",
              class: "mr-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode("改善点")
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_70, [
              _createVNode(_component_ReviewComment, {
                comment: evaluation.badPoint,
                maxLength: 150
              }, null, 8, ["comment"])
            ]),
            _createTextVNode(),
            _hoisted_71
          ]))
        }), 128)),
        _createTextVNode(),
        _createElementVNode("div", null, [
          (_ctx.readOldestReview)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-order mt-2",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showNextAnonymousEvaluation && _ctx.showNextAnonymousEvaluation(...args)))
              }, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-down",
                  class: "mr-1"
                }),
                _createTextVNode("\n            さらにレビューを表示する（残り" + _toDisplayString(_ctx.remainingAnonymousEvaluationCount) + "件）\n          ", 1)
              ]))
            : (
              _ctx.anonymousEvaluations.length >= _ctx.upperLimitOfAnonymousEvaluation
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, "\n            コメントは最新の" + _toDisplayString(_ctx.upperLimitOfAnonymousEvaluation) + "件のみが表示されています\n          ", 1))
              : _createCommentVNode("", true)
        ]),
        _createTextVNode(),
        (_ctx.order.openedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, "\n          掲載日：" + _toDisplayString(_ctx.formattedOpenedAt), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}